/* Verzendetiket.nl labelvinder
   Leest de gegevens uit <script type="application/json" data-vinder-data> in de sectie ve-hero-vinder.
   Stappen: vervoerder, printer (met hulpvraag), aantal per maand, advies met "In winkelwagen". */
(function () {
  'use strict';

  var PRINTERS = [
    { id: 'klein', naam: 'Labelprinter, bureaumodel', key: 'desk' },
    { id: 'budget', naam: 'Voordelige 4 inch printer', key: 'budget' },
    { id: 'groot', naam: 'Industriële printer', key: 'ind' },
    { id: 'a4', naam: 'Gewone printer', key: 'office' },
    { id: 'merk', naam: 'Dymo of Brother', key: 'dymo' },
    { id: 'weetniet', naam: 'Ik weet het niet', key: 'unknown' }
  ];
  var KERNEN = [
    { id: 'klein', naam: 'Klein kokertje', sub: 'Ongeveer 2,5 cm doorsnede', r: 6 },
    { id: 'groot', naam: 'Groot kokertje', sub: 'Ongeveer 7,6 cm doorsnede', r: 14 },
    { id: 'a4', naam: 'Ik print op A4-vellen', sub: 'Met een gewone printer', r: 0 },
    { id: 'geen', naam: 'Ik heb nog geen printer', sub: 'Ik begin net met verzenden', r: 0 }
  ];
  var VOLUMES = [
    { label: 'Tot 100', v: 60 },
    { label: '100 tot 500', v: 300 },
    { label: '500 tot 2.000', v: 1200 },
    { label: '2.000 tot 10.000', v: 5000 },
    { label: 'Meer dan 10.000', v: 20000 }
  ];
  /* Pictogrammen bij de printers, alleen in de grote weergave */
  var PICON = {
    klein: '<rect x="3" y="9" width="18" height="10" rx="2"/><path d="M7 9V7a5 3 0 0 1 10 0v2M7 15h10"/>',
    budget: '<rect x="5" y="8" width="14" height="11" rx="2"/><path d="M8 8V5h8v3M9 14h6"/>',
    groot: '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="M6 8h8M6 12h5"/><circle cx="17" cy="12" r="2.5"/>',
    a4: '<path d="M6 9V3h12v6"/><rect x="3" y="9" width="18" height="8" rx="2"/><path d="M6 14h12v7H6z"/>',
    merk: '<rect x="6" y="3" width="12" height="18" rx="3"/><path d="M9 7h6M9 17h6"/>',
    weetniet: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6V14M12 17.5v.01"/>'
  };
  var VINK = '<span class="ve-vink" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 12 12"><path d="M2.5 6.2l2.3 2.3 4.7-5"></path></svg></span>';
  var DOOS = '<svg width="70" height="62" viewBox="0 0 70 62" aria-hidden="true"><polygon points="6,18 35,6 64,18 35,30" fill="#E7C49A"></polygon><polygon points="6,18 35,30 35,60 6,48" fill="#D9AE7C"></polygon><polygon points="35,30 64,18 64,48 35,60" fill="#C99A66"></polygon><path d="M20 12l29 12" stroke="#B9895A" stroke-width="5"></path><polygon points="41,36 58,29 58,41 41,48" fill="#FFFFFF"></polygon></svg>';

  var euro = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  var getal = new Intl.NumberFormat('nl-NL');
  function geld(centen) { return euro.format(centen / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function meet(naam, extra) {
    var data = Object.assign({ event: naam }, extra || {});
    try { (window.dataLayer = window.dataLayer || []).push(data); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', naam, extra || {}); } catch (e) {}
  }

  function Vinder(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-vinder-data]');
    this.d = JSON.parse(dataEl.textContent);
    this.scherm = root.querySelector('[data-vinder-scherm]');
    this.stappen = root.querySelectorAll('[data-vinder-voortgang] .ve-voortgang__stap');
    this.label = root.querySelector('[data-vinder-label]');
    this.podium = root.querySelector('[data-vinder-stage]');
    this.s = { stap: 1, cars: [], printer: null, kern: null, vol: 1, extra: {}, toegevoegd: {} };
    /* Komt de bezoeker via "Of kies op printer" in het menu (?printer=klein), dan staat die printer al klaar */
    try {
      var vooraf = new URLSearchParams(window.location.search).get('printer');
      if (vooraf && PRINTERS.some(function (p) { return p.id === vooraf; })) this.s.printer = vooraf;
    } catch (e) {}
    /* Komt de bezoeker via een vervoerderslogo (?vervoerder=postnl), dan staat die vervoerder al aangevinkt en gaat de vinder door naar de printer */
    try {
      var vv = (new URLSearchParams(window.location.search).get('vervoerder') || '').toLowerCase();
      if (vv) {
        var gekozen = [];
        this.d.vervoerders.forEach(function (c, i) {
          var n = String(c.naam || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          if (n === vv || n.indexOf(vv) > -1) gekozen.push(String(i));
        });
        if (gekozen.length) { this.s.cars = gekozen; this.s.stap = 2; }
      }
    } catch (e) {}
    var self = this;
    root.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-actie]');
      if (!knop || !root.contains(knop) || knop.disabled) return;
      self.actie(knop.getAttribute('data-actie'), knop.getAttribute('data-id'));
    });
    this.render(false);
  }

  Vinder.prototype.set = function (wijziging, focus) {
    Object.assign(this.s, wijziging);
    this.render(focus);
  };

  Vinder.prototype.actie = function (actie, id) {
    var s = this.s;
    if (actie === 'car') {
      var cars = s.cars.slice();
      var i = cars.indexOf(id);
      if (i > -1) cars.splice(i, 1); else cars.push(id);
      this.set({ cars: cars });
    } else if (actie === 'printer') {
      this.set({ printer: id, kern: null, extra: {} }, id === 'weetniet');
      if (id !== 'weetniet') meet('ve_vinder_printer', { printer: id });
    } else if (actie === 'kern') {
      this.set({ kern: id, extra: {} });
      meet('ve_vinder_printer', { printer: 'weetniet_' + id });
    } else if (actie === 'terugprinters') {
      this.set({ printer: null, kern: null }, true);
    } else if (actie === 'vol') {
      this.set({ vol: parseInt(id, 10), extra: {} });
    } else if (actie === 'volgende') {
      if (s.stap === 1) meet('ve_vinder_vervoerder', { vervoerders: this.carNamen().join(', ') });
      if (s.stap === 3) meet('ve_vinder_resultaat', { volume: VOLUMES[s.vol].label });
      this.set({ stap: Math.min(4, s.stap + 1), toegevoegd: {} }, true);
    } else if (actie === 'vorige') {
      this.set({ stap: Math.max(1, s.stap - 1) }, true);
    } else if (actie === 'opnieuw') {
      this.set({ stap: 1, cars: [], printer: null, kern: null, vol: 1, extra: {}, toegevoegd: {} }, true);
    } else if (actie === 'min' || actie === 'plus') {
      var r = this.resultaten().filter(function (x) { return x.fam === id; })[0];
      if (!r) return;
      var doel = actie === 'min' ? r.dozen - 1 : r.dozen + 1;
      if (doel < 1) return;
      var extra = Object.assign({}, s.extra);
      extra[id] = doel - r.basis;
      var toegevoegd = Object.assign({}, s.toegevoegd); delete toegevoegd[id];
      this.set({ extra: extra, toegevoegd: toegevoegd });
    } else if (actie === 'koop') {
      this.koop(id);
    }
  };

  Vinder.prototype.carNamen = function () {
    var d = this.d;
    return this.s.cars.map(function (id) {
      if (id === 'ander') return 'andere vervoerders';
      var c = d.vervoerders[parseInt(id, 10)];
      return c ? c.naam : '';
    });
  };

  Vinder.prototype.families = function () {
    var d = this.d, a6 = [], dhl = false;
    this.s.cars.forEach(function (id) {
      if (id === 'ander') { a6.push('andere vervoerders'); return; }
      var c = d.vervoerders[parseInt(id, 10)];
      if (!c) return;
      if (c.formaat === 'dhl') dhl = true; else a6.push(c.naam);
    });
    var f = [];
    if (a6.length) f.push({ fam: 'a6', past: 'Past bij ' + a6.join(', ') });
    if (dhl) f.push({ fam: 'dhl', past: 'Past bij DHL, formaat 102 × 210 mm' });
    return f;
  };

  Vinder.prototype.effectief = function () {
    var s = this.s;
    if (s.printer === 'weetniet') return s.kern;
    return s.printer;
  };

  Vinder.prototype.productKey = function () {
    var e = this.effectief();
    if (e === 'klein' || e === 'budget') return 'klein';
    if (e === 'groot') return 'groot';
    if (e === 'a4' || e === 'geen') return 'a4';
    return null;
  };

  Vinder.prototype.resultaten = function () {
    var s = this.s, d = this.d, key = this.productKey();
    if (!key) return [];
    var L = VOLUMES[s.vol].v, maanden = d.maandenVooruit || 3;
    return this.families().map(function (f) {
      var p = d.producten[f.fam] && d.producten[f.fam][key];
      if (!p) return null;
      var stap = Math.max(1, p.stap || 1);
      var perDoos = (p.perEenheid || 0) * stap;
      var basis = perDoos > 0 ? Math.max(1, Math.ceil(L * maanden / perDoos)) : 1;
      var dozen = Math.max(1, basis + (s.extra[f.fam] || 0));
      var labels = dozen * perDoos;
      var mnd = perDoos > 0 ? labels / L : 0;
      return { fam: f.fam, past: f.past, p: p, stap: stap, perDoos: perDoos, basis: basis, dozen: dozen, aantal: dozen * stap, labels: labels, maanden: mnd, totaal: dozen * stap * p.prijs };
    }).filter(Boolean);
  };

  Vinder.prototype.koop = function (fam) {
    var self = this;
    var r = this.resultaten().filter(function (x) { return x.fam === fam; })[0];
    if (!r) return;
    var knop = this.root.querySelector('[data-actie="koop"][data-id="' + fam + '"]');
    if (knop) { knop.disabled = true; knop.textContent = 'Bezig…'; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    /* Vraag dezelfde secties op als het thema zelf doet, zodat de winkelwagenlade meteen klopt */
    var secties = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: secties } }));
    var body = { items: [{ id: r.p.id, quantity: r.aantal }] };
    if (secties.length) { body.sections = secties.join(','); body.sections_url = window.location.pathname; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; });
    }).then(function (uit) {
      if (!uit.ok) throw new Error(uit.json && (uit.json.description || uit.json.message) || 'Toevoegen lukte niet');
      var t = Object.assign({}, self.s.toegevoegd); t[fam] = 'ok';
      self.set({ toegevoegd: t });
      meet('add_to_cart', { currency: 'EUR', value: r.totaal / 100, items: [{ item_id: String(r.p.id), item_name: r.p.titel, quantity: r.aantal }] });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      /* Minimog: lade verversen en openen, net als bij "In winkelwagen" op de productpagina */
      try {
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: uit.json, productVariantId: String(r.p.id) });
        }
        var lade = document.querySelector('m-cart-drawer');
        if (lade && typeof lade.open === 'function' && window.MinimogSettings && window.MinimogSettings.enable_cart_drawer) lade.open();
      } catch (e) {}
    }).catch(function (err) {
      var t = Object.assign({}, self.s.toegevoegd); t[fam] = 'fout:' + err.message;
      self.set({ toegevoegd: t });
    });
  };

  Vinder.prototype.render = function (focus) {
    var s = this.s, d = this.d, html = '';
    for (var i = 0; i < this.stappen.length; i++) {
      var n = i + 1;
      this.stappen[i].classList.toggle('is-actief', s.stap === n);
      this.stappen[i].classList.toggle('is-klaar', s.stap > n);
    }
    if (s.stap === 1) html = this.stap1();
    else if (s.stap === 2 && s.printer === 'weetniet') html = this.stap2hulp();
    else if (s.stap === 2) html = this.stap2();
    else if (s.stap === 3) html = this.stap3();
    else html = this.stap4();
    this.scherm.innerHTML = html;
    this.renderLabel();
    if (focus) {
      var kop = this.scherm.querySelector('h2');
      if (kop) kop.focus({ preventScroll: true });
      // Op mobiel: zorg dat de bovenkant van de vinder in beeld staat na een nieuwe stap
      var r = this.root.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) {
        var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: window.pageYOffset + r.top - 90, behavior: stil ? 'auto' : 'smooth' });
      }
    }
  };

  Vinder.prototype.renderLabel = function () {
    if (!this.label) return;
    var fam = this.families();
    var e = this.effectief();
    var opA4 = e === 'a4' || e === 'geen';
    var alleenDhl = fam.length === 1 && fam[0].fam === 'dhl' && !opA4;
    this.label.style.aspectRatio = alleenDhl ? '102 / 210' : '102 / 150';
    var maat = this.label.querySelector('[data-label-maat]');
    var chip = this.label.querySelector('[data-label-chip]');
    if (maat) maat.textContent = alleenDhl ? '102 × 210' : (opA4 ? '105 × 148' : '102 × 150');
    if (chip) chip.textContent = e === 'groot' ? 'kern 76 mm' : opA4 ? 'A4-vel' : 'kern 25 mm';
    if (this.podium) this.renderPodium(e);
  };

  /* Grote weergave: labelvoorbeeld met logo's, rol of vel en een samenvatting van de keuzes */
  Vinder.prototype.renderPodium = function (e) {
    var s = this.s, d = this.d, pod = this.podium;
    var media = 'leeg';
    if (e === 'klein' || e === 'budget') media = 'rol-klein';
    else if (e === 'groot') media = 'rol-groot';
    else if (e === 'a4' || e === 'geen') media = 'a4';
    pod.setAttribute('data-media', media);
    var mt = pod.querySelector('[data-stage-mediatekst]');
    if (mt) mt.textContent = { leeg: 'Kies je printer', 'rol-klein': 'Rol, kern 25 mm', 'rol-groot': 'Rol, kern 76 mm', a4: 'A4-vel, 4 labels' }[media];
    var cars = s.cars.filter(function (id) { return id !== 'ander'; }).map(function (id) { return d.vervoerders[parseInt(id, 10)]; }).filter(Boolean);
    var logos = cars.slice(0, 3).map(function (c) {
      return c.logo ? '<img src="' + esc(c.logo) + '" alt="' + esc(c.naam) + '" width="54" height="15">' : '<span>' + esc(c.naam) + '</span>';
    }).join('');
    if (cars.length > 3) logos += '<span>+' + (cars.length - 3) + '</span>';
    if (!cars.length && s.cars.length) logos = '<span>Andere vervoerder</span>';
    var lg = pod.querySelector('[data-stage-logos]');
    if (lg) lg.innerHTML = logos;
    var printer = '';
    if (s.printer === 'weetniet' && s.kern) {
      printer = KERNEN.filter(function (k) { return k.id === s.kern; })[0].naam;
    } else if (s.printer && s.printer !== 'weetniet') {
      printer = PRINTERS.filter(function (p) { return p.id === s.printer; })[0].naam;
    }
    var sum = {
      vervoerder: this.carNamen().join(', ') || 'Nog niet gekozen',
      printer: printer || 'Nog niet gekozen',
      aantal: s.stap >= 4 ? VOLUMES[s.vol].label + ' pakketten' : 'Nog niet gekozen'
    };
    Object.keys(sum).forEach(function (k) {
      var el = pod.querySelector('[data-stage-sum="' + k + '"]');
      if (el) el.textContent = sum[k];
    });
    var st = pod.querySelector('[data-stage-status]');
    if (st) st.textContent = ['', 'Kies je vervoerder', 'Kies je printer', 'Hoeveel verstuur je?', 'Dit label past bij jou'][s.stap] || '';
  };

  Vinder.prototype.kop = function (titel, sub) {
    return '<div class="ve-vinder__kop"><h2 class="ve-vinder__vraag" tabindex="-1">' + titel + '</h2>' + (sub ? '<p class="ve-zacht">' + sub + '</p>' : '') + '</div>';
  };

  Vinder.prototype.stap1 = function () {
    var s = this.s, d = this.d;
    var tegels = d.vervoerders.map(function (c, i) {
      var aan = s.cars.indexOf(String(i)) > -1;
      var inhoud = c.logo ? '<img class="ve-vinder__logo" src="' + esc(c.logo) + '" alt="' + esc(c.naam) + '" loading="lazy" width="120" height="32">' : '<span class="ve-tegel__naam">' + esc(c.naam) + '</span>';
      return '<button type="button" class="ve-tegel ve-vinder__car" aria-pressed="' + aan + '" data-actie="car" data-id="' + i + '">' + inhoud + (c.tag ? '<span class="ve-tegel__sub ve-mono">' + esc(c.tag) + '</span>' : '') + '</button>';
    }).join('');
    var ander = d.andereTekst ? '<button type="button" class="ve-vinder__ander" aria-pressed="' + (s.cars.indexOf('ander') > -1) + '" data-actie="car" data-id="ander">+ ' + esc(d.andereTekst) + '</button>' : '';
    var tip = d.platformTip ? '<div class="ve-vinder__tip">' + d.platformTip + '</div>' : '';
    return this.kop('Met welke vervoerder verstuur je?', 'Meerdere kiezen mag.') +
      '<div class="ve-vinder__tegels ve-vinder__tegels--3">' + tegels + '</div>' + ander + tip +
      '<div class="ve-vinder__nav ve-vinder__nav--eind"><button type="button" class="ve-btn ve-btn--primair" data-actie="volgende"' + (s.cars.length ? '' : ' disabled') + '>Volgende</button></div>';
  };

  Vinder.prototype.stap2 = function () {
    var s = this.s, d = this.d, groot = !!this.podium;
    var tegels = PRINTERS.map(function (p) {
      var sub = (d.printerSub && d.printerSub[p.key]) || '';
      var icoon = groot && PICON[p.id] ? '<span class="ve-vinder__picon" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + PICON[p.id] + '</svg></span>' : '';
      return '<button type="button" class="ve-tegel" aria-pressed="' + (s.printer === p.id) + '" data-actie="printer" data-id="' + p.id + '">' + icoon + '<span class="ve-tegel__naam">' + p.naam + '</span><span class="ve-tegel__sub">' + esc(sub) + '</span></button>';
    }).join('');
    return this.kop('Waarmee print je je labels?', 'Je printer bepaalt of je een rol of A4 nodig hebt, en welke rol past.') +
      '<div class="ve-vinder__tegels ve-vinder__tegels--2">' + tegels + '</div>' +
      '<div class="ve-vinder__nav"><button type="button" class="ve-linkknop" data-actie="vorige">Vorige</button><button type="button" class="ve-btn ve-btn--primair" data-actie="volgende"' + (s.printer ? '' : ' disabled') + '>Volgende</button></div>';
  };

  Vinder.prototype.stap2hulp = function () {
    var s = this.s, d = this.d;
    var tegels = KERNEN.map(function (k) {
      var svg = k.r ? '<svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true" style="flex-shrink:0"><circle cx="20" cy="20" r="18" fill="#FFFFFF" stroke="#9FC9DE" stroke-width="1.5"></circle><circle cx="20" cy="20" r="' + k.r + '" fill="#F2F6F9" stroke="#FB6004" stroke-width="2.5"></circle></svg>' : '';
      return '<button type="button" class="ve-tegel" aria-pressed="' + (s.kern === k.id) + '" data-actie="kern" data-id="' + k.id + '"><span class="ve-vinder__kern">' + svg + '<span><span class="ve-tegel__naam">' + k.naam + '</span><br><span class="ve-tegel__sub">' + k.sub + '</span></span></span></button>';
    }).join('');
    var bel = d.telefoon ? '<p class="ve-zacht ve-vinder__klein">Nog steeds geen idee? Bel <a href="tel:' + esc(d.telefoonLink) + '" class="ve-mono">' + esc(d.telefoon) + '</a>, we zoeken het samen uit.</p>' : '';
    return this.kop('Geen probleem. Kijk even naar je huidige rol.', 'Het kartonnen kokertje in het midden verraadt welke printer je hebt.') +
      '<div class="ve-vinder__tegels ve-vinder__tegels--2">' + tegels + '</div>' + bel +
      '<div class="ve-vinder__nav"><button type="button" class="ve-linkknop" data-actie="terugprinters">Terug naar printers</button><button type="button" class="ve-btn ve-btn--primair" data-actie="volgende"' + (s.kern ? '' : ' disabled') + '>Volgende</button></div>';
  };

  Vinder.prototype.stap3 = function () {
    var s = this.s;
    var chips = VOLUMES.map(function (v, i) {
      return '<button type="button" class="ve-chip" aria-pressed="' + (s.vol === i) + '" data-actie="vol" data-id="' + i + '">' + v.label + '</button>';
    }).join('');
    return this.kop('Hoeveel pakketten verstuur je per maand?', 'Een schatting is genoeg. Dan rekenen we uit hoeveel je bestelt.') +
      '<div class="ve-chips">' + chips + '</div>' +
      '<div class="ve-vinder__nav"><button type="button" class="ve-linkknop" data-actie="vorige">Vorige</button><button type="button" class="ve-btn ve-btn--primair" data-actie="volgende">Toon mijn label</button></div>';
  };

  Vinder.prototype.stap4 = function () {
    var s = this.s, d = this.d, self = this;
    var e = this.effectief();
    var html = this.kop('Dit label past bij jou', '');
    if (e === 'merk') {
      return this.kop('Even checken', '') +'<div class="ve-melding ve-melding--tip ve-vinder__merk"><h3 class="ve-h3">We checken even wat in jouw printer past</h3><p>Bij Dymo en Brother hangt het af van het model. Sommige werken alleen met originele rollen van het merk. Stuur ons je printermodel, dan hoor je binnen een werkdag welk label je nodig hebt.</p><div class="ve-vinder__knoppen">' +
        (d.contactUrl ? '<a class="ve-btn ve-btn--primair" href="' + esc(d.contactUrl) + '">Stuur je printermodel</a>' : '') +
        (d.telefoon ? '<a class="ve-btn ve-btn--rustig ve-mono" href="tel:' + esc(d.telefoonLink) + '">' + esc(d.telefoon) + '</a>' : '') +
        '</div></div>' + this.opnieuw();
    }
    var res = this.resultaten();
    if (!res.length) {
      return html + '<div class="ve-melding ve-melding--tip">We konden geen passend product vinden. Bel of mail ons even, dan zoeken we het samen uit.</div>' + this.opnieuw();
    }
    var L = VOLUMES[s.vol].v, som = 0;
    res.forEach(function (r) {
      som += r.totaal;
      var p = r.p, ken = (p.kenmerken || []).slice(0, 3);
      var regels = ken.concat([r.past]).map(function (t) { return '<li>' + VINK + '<span>' + esc(t) + '</span></li>'; }).join('');
      var noot = '';
      if (e === 'budget') noot = 'Twijfel je of de rol in jouw printer past? Bel of mail ons je printermodel, dan checken we het voor je.';
      if (e === 'geen') noot = 'Start je net? Dan is A4 de makkelijkste start. Verstuur je straks meer dan zo’n 10 pakketten per dag, dan werkt een labelprinter een stuk sneller.';
      var meervoud = p.eenheid === 'rol' ? 'rollen' : (p.eenheid === 'doos' ? 'dozen' : p.eenheid);
      var inhoud = r.stap > 1 ? getal.format(r.aantal) + ' ' + meervoud + ' · ' + getal.format(r.labels) + ' labels' : getal.format(r.labels) + ' labels';
      var dozenTekst = r.dozen === 1 ? '1 doos' : r.dozen + ' dozen';
      var minRegel = r.stap > 1 ? 'Minimale afname is 1 doos (' + r.stap + ' ' + meervoud + '). Geen abonnement: je bestelt opnieuw wanneer jij wilt.' : 'Minimale afname is 1 doos. Geen abonnement: je bestelt opnieuw wanneer jij wilt.';
      var mndTekst = r.maanden < 10 ? r.maanden.toFixed(1).replace('.', ',') : Math.round(r.maanden);
      var pct = Math.min(100, Math.round(r.maanden / 12 * 100));
      var status = s.toegevoegd[r.fam] || '';
      var knop;
      if (status === 'ok') {
        knop = '<span class="ve-vinder__ok">' + VINK + 'Toegevoegd</span><a class="ve-btn ve-btn--primair" href="' + esc(d.cartUrl) + '">Naar winkelwagen</a>';
      } else {
        knop = '<a href="' + esc(p.url) + '" class="ve-vinder__bekijk">Bekijk product</a><button type="button" class="ve-btn ve-btn--primair" data-actie="koop" data-id="' + r.fam + '"' + (p.beschikbaar === false ? ' disabled' : '') + '>' + (p.beschikbaar === false ? 'Tijdelijk uitverkocht' : 'In winkelwagen') + '</button>';
      }
      var fout = status.indexOf('fout:') === 0 ? '<p class="ve-melding ve-melding--fout">' + esc(status.slice(5)) + '</p>' : '';
      html += '<div class="ve-vinder__res">' +
        '<div class="ve-vinder__res-kop"><span class="ve-mono ve-vinder__label-klein">JOUW LABEL</span><h3 class="ve-vinder__res-titel">' + esc(p.titel) + '</h3><ul class="ve-checks">' + regels + '</ul>' +
        (noot ? '<p class="ve-melding ve-melding--tip">' + noot + '</p>' : '') + '</div>' +
        '<div class="ve-vinder__bestel"><div class="ve-vinder__bestel-rij"><div class="ve-vinder__doos">' + DOOS + '<span class="ve-vinder__badge ve-mono">×' + r.dozen + '</span></div>' +
        '<div class="ve-vinder__aantal"><span class="ve-mono ve-vinder__label-klein">JE BESTELT</span><strong>' + dozenTekst + '</strong><span class="ve-zacht">' + inhoud + '</span></div>' +
        '<div class="ve-vinder__stepper"><button type="button" aria-label="Een doos minder" data-actie="min" data-id="' + r.fam + '"' + (r.dozen <= 1 ? ' disabled' : '') + '>−</button><span class="ve-mono" aria-live="polite">' + r.dozen + '</span><button type="button" aria-label="Een doos meer" data-actie="plus" data-id="' + r.fam + '">+</button></div></div>' +
        (r.perDoos > 0 ? '<div class="ve-vinder__meter"><span><strong>Genoeg voor ±' + mndTekst + ' maanden</strong> bij ' + getal.format(L) + ' pakketten per maand</span><div class="ve-vinder__balk"><div style="width:' + pct + '%"></div></div><div class="ve-vinder__schaal ve-mono"><span>0</span><span>3 mnd</span><span>6 mnd</span><span>9 mnd</span><span>12 mnd</span></div></div>' : '') +
        '<p class="ve-vinder__min"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#1180B8" stroke-width="1.6" aria-hidden="true"><circle cx="8" cy="8" r="6.5"></circle><path d="M8 7.2v4M8 4.8v.2" stroke-linecap="round"></path></svg><span>' + minRegel + '</span></p></div>' +
        '<div class="ve-vinder__voet"><div><strong class="ve-vinder__prijs">' + geld(r.totaal) + '</strong><span class="ve-zacht ve-vinder__klein">excl. btw' + (d.staffelTekst ? ', ' + esc(d.staffelTekst) : '') + '</span></div><div class="ve-vinder__knoppen">' + knop + '</div></div>' + fout +
        '</div>';
    });
    if (d.gratisVanaf) {
      var nog = d.gratisVanaf - som;
      html += '<p class="ve-vinder__gratis' + (nog <= 0 ? ' is-gratis' : '') + '">' + (nog <= 0 ? 'Gratis verzending.' : 'Nog ' + geld(nog) + ' tot gratis verzending.') + '</p>';
    }
    var key = this.productKey();
    if (d.palletUrl && L >= (d.palletVanaf || 8000) && key !== 'a4') {
      html += '<p class="ve-melding ve-melding--info"><strong>Grote afname?</strong> ' + esc(d.palletTekst || 'Op een pallet betaal je minder per rol.') + ' <a href="' + esc(d.palletUrl) + '">Bekijk palletdeals</a></p>';
    }
    return html + this.opnieuw();
  };

  Vinder.prototype.opnieuw = function () {
    return '<button type="button" class="ve-linkknop" data-actie="opnieuw">Opnieuw beginnen</button>';
  };

  function start() {
    var roots = document.querySelectorAll('[data-ve-vinder]:not([data-gestart])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-gestart', '');
      try { new Vinder(roots[i]); } catch (e) { if (window.console) console.error('Labelvinder', e); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
